import { KyrgyzstanWebviewOwnerApi } from 'shared/api/kyrgyzstan/webview-owner'

import type { ObjectApplication } from '../model/types'

import { mapOwnerOrderToObjectApplication } from './map-owner-order-to-object-application'

interface FetchObjectApplicationsPageParams {
  page: number
  pageSize: number
  signal?: AbortSignal
}

export interface ObjectApplicationsPageResult {
  items: ObjectApplication[]
  page: number
  totalPages: number
}

export const fetchObjectApplicationsPage = async ({
  page,
  pageSize,
  signal,
}: FetchObjectApplicationsPageParams): Promise<ObjectApplicationsPageResult> => {
  const { data } = await KyrgyzstanWebviewOwnerApi.getOrders(
    {
      page,
      page_size: pageSize,
      is_booking: false,
    },
    signal,
  )

  return {
    items: data.data.map(mapOwnerOrderToObjectApplication),
    page: data.page,
    totalPages: data.total_pages || 1,
  }
}
